/**
 * Strict boot-flag env parse for customer PWA feature flags (Vite / Jest SSOT).
 * Must stay behavior-identical to `scripts/lib/parseCustomerBootFlagEnv.mjs`
 * (Node postbuild) — locked by `customerFeatureFlags.loyaltyNav.test.ts`.
 * Only the literal string `'true'` enables — not `'TRUE'`, `'1'`, `'yes'`, etc.
 */
export function parseCustomerBootFlagEnv(
  value: string | undefined,
): boolean {
  return value === 'true';
}
